export default __webpack_public_path__ + "36ea2fdaf722f3283d52959463653475.png";